import React from 'react';

interface Props {
  children: React.ReactNode;
}

export default function TableHead({ children }: Props): JSX.Element {
  return <thead className="app-table__head">{children}</thead>;
}
